import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useEffect, useMemo } from "react";
import { z } from "zod";
import LoginPageContent from "./-components/LoginPageContent";
import { buildBrandTitle } from "@nitro-ape/shared/lib/brand-config";
import { getEnv } from "@/lib/env";
import { usePrivy, useWallets } from "@privy-io/react-auth";
import { usePrivyAuth } from "@/hooks/use-privy-auth";

const schema = z.object({
  ref: z.string().optional(),
});

export const Route = createFileRoute("/login/")({
  validateSearch: (search) => {
    return schema.parse(search);
  },
  head: () => ({
    meta: [{ title: buildBrandTitle(getEnv, "Login") }],
  }),
  component: LoginPage,
});

function LoginPage() {
  const { login, authenticated } = usePrivy();
  const { handlePrivyLogin, isLoading } = usePrivyAuth();
  const { wallets, ready } = useWallets();

  const filteredWallets = useMemo(
    () => wallets.filter((wallet) => wallet.walletClientType === "privy"),
    [wallets],
  );
  const { ref } = useSearch({ from: "/login/" });

  useEffect(() => {
    if (authenticated && ready && filteredWallets.length > 0) {
      handlePrivyLogin(ref);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, ready, wallets]);

  return <LoginPageContent isLoading={isLoading} onLogin={login} />;
}
